import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from '@api/services.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-services-ticket',
  templateUrl: './services-ticket.component.html',
  styleUrls: ['./services-ticket.component.scss']
})
export class ServicesTicketComponent implements OnInit{
  trackingId: number;
  public destroy$ = new Subject<void>();
  ticket;
  interval;
  ticketForm: FormGroup;

  constructor(
    private servicesService: ServicesService,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
  ){}

  ngOnInit(): void {
    this.getTrackingId();
    this.  getInitialForm();
    this.getTicket();
    this.interval = setInterval(() => {
      this.getTicket();
    }, 15000);
  }
  getTrackingId() {
    this.trackingId = this.activeRoute.snapshot.params['tracking-id'];
  }
  getTicket() {
    this.servicesService.getTicketService(this.trackingId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.ticket = res?.responseList;
      }
    )
  }
  getInitialForm() {
    this.ticketForm = this.formBuilder.group(
      {
        message: [],
      }
    );
  }
  sendMessage(){
    this.servicesService.sendTicket(this.trackingId, this.ticketForm?.value).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res.status === 200 || res.status === 201) {
        this.getTicket();
        this.ticketForm.reset();
      }
    });
  }
}
